"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLINICAL_ORDER_WORKFLOW_RESPONSE_EXAMPLE = void 0;
const clinical_common_response_1 = require("./clinical-common.response");
exports.CLINICAL_ORDER_WORKFLOW_RESPONSE_EXAMPLE = {
    order: clinical_common_response_1.CLINICAL_ORDER_RESPONSE_EXAMPLE,
    timeline: [clinical_common_response_1.CLINICAL_TIMELINE_ENTRY_RESPONSE_EXAMPLE],
    notificationSent: false,
};
//# sourceMappingURL=clinical-order.response.js.map